// extracted by mini-css-extract-plugin
export default {"RefPillOcticon":"RefPill-module__RefPillOcticon__WybMdxt","RefPillTruncate":"RefPill-module__RefPillTruncate__auTEj60","RefPillText":"RefPill-module__RefPillText__JRSZ_II"};